import React, { useEffect } from "react";
import "./toast.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons";

interface ToastProps {
  show: boolean;
  onClose: () => void;
}

const SuccessToast: React.FC<ToastProps> = ({ show, onClose }) => {
  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [show, onClose]);

  return (
    <div
      className={`toast-container position-fixed top-0 end-0 ${
        show ? "show" : "hide"
      }`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="toast-body text-white bg-success rounded-pill px-4 py-2 fs-4 m-3 d-flex align-items-center gap-2">
        <FontAwesomeIcon style={{ fontSize: "18px" }} icon={faCircleCheck} />
        <strong className="me-auto">Success</strong>
      </div>
    </div>
  );
};

export default SuccessToast;
